import CarrotLogo from "../img/carrot.svg"

export default function ApplicationTitle(props) {
    return (
        <div>
            <div className="flex text-center justify-center mb-2 text-4xl font-bold text-black">
                {props.mainTitle}
            </div>
            <div className="flex text-center justify-center mb-6 text-base font-light text-black">
                {props.subTitle}
            </div>
        </div>
    )
}